import { render, staticRenderFns } from "./ModalSubPartitaDeleteAll.vue?vue&type=template&id=37d059de"
import script from "./ModalSubPartitaDeleteAll.vue?vue&type=script&lang=js"
export * from "./ModalSubPartitaDeleteAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports